import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/sentry/box/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/sentry/box/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/sentry/box/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/sentry/box/save', params, options);

export const update = (params, options) =>
  request.post('/api/park/sentry/box/update', params, options);

export const getBondPassages = (params, options) =>
  request.post('/api/park/sentrybox/passage/list', qs.stringify(params), options);

export const sentryBoxBindPassage = (params, options) =>
  request.post('/api/park/sentrybox/passage/bind', params, options);

export const getSentryBoxList = (params, options) =>
  request.get('/api/park/sentry/box/list', Object.assign({}, options, { params }));
